import _ from 'underscore';
import {
  Clicks,
  Impressions,
  CTR,
  AverageCPC,
  AverageCPM,
  Spend,
  TotalSpend,
} from './performance';
import {
  CPA,
  PartialConversionCPA,
  Conversions,
  ConversionsCredit,
  ConversionRate,
  PartialConversionRate,
  AdvertiserReportedRevenue,
  RevenueOnAdSpend,
} from './conversions';
import { IMetricDefinition, IMetricCategory } from '../../types';

export const Metrics = {
  Clicks,
  Impressions,
  CTR,
  AverageCPC,
  AverageCPM,
  Spend,
  TotalSpend,
  CPA,
  PartialConversionCPA,
  Conversions,
  ConversionsCredit,
  ConversionRate,
  PartialConversionRate,
  AdvertiserReportedRevenue,
  RevenueOnAdSpend,
};

const defaultPerformanceMetrics: IMetricDefinition[] = [
  Clicks,
  Impressions,
  CTR,
  AverageCPC,
  Spend,
];

const defaultConversionsMetrics: IMetricDefinition[] = [
  CPA,
  Conversions,
  ConversionRate,
  AdvertiserReportedRevenue,
  RevenueOnAdSpend,
];

/**
 * @param {string} titleKey i18n key for category title
 * @param {IMetricDefinition[]} metrics columns to display under this category
 * @returns {IMetricCategory} for custom columns configuration
 */
export const MetricCategory = (titleKey: string, metrics: IMetricDefinition[] = []): IMetricCategory => ({ titleKey, metrics });

/**
 * @param {IMetricDefinition[]} metrics "Performance" category metrics
 * @returns {IMetricCategory} for custom columns configuration
 */
const PerformanceCategory = (metrics: IMetricDefinition[] = defaultPerformanceMetrics): IMetricCategory => MetricCategory('Performance', metrics);

/**
 * @param {IMetricDefinition[]} metrics "Conversions" category metrics
 * @returns {IMetricCategory} for custom columns configuration
 */
const ConversionsCategory = (metrics: IMetricDefinition[] = defaultConversionsMetrics): IMetricCategory => MetricCategory('Conversions', metrics);

/**
 * @param {IMetricDefinition[]} [perfMetrics] metrics to group under 'Performance' category
 * @param {IMetricDefinition[]} [convMetrics] metrics to group under 'Conversions' category
 * @returns {IMetricCategory[]} formatted value for config(s)
 */
export const MetricCategories = (perfMetrics?: IMetricDefinition[], convMetrics?: IMetricDefinition[]): IMetricCategory[] => [
  PerformanceCategory(perfMetrics),
  ConversionsCategory(convMetrics),
];

export function getAllMetrics(metricCategories: IMetricCategory[]): string[] {
  const allMetrics: string[] = [];

  _.each(metricCategories, (category) => {
    _.each(category.metrics, (metric) => allMetrics.push(metric.metric));
  });

  return allMetrics;
}
